export default __webpack_public_path__ + "static/media/back.445e0142.svg";